import type { User } from 'api/data.types'

const checkUserHasOnGoingTestPeriod = (user: User): boolean => {
  const reader = user?.reader
  const testPeriods = reader?.testPeriods

  if (!testPeriods || !testPeriods.length) return false

  const today = new Date()

  const onGoingTrials = testPeriods.filter(testPeriod => {
    const limitDate = new Date(testPeriod.createdAt)
    limitDate.setDate(limitDate.getDate() + testPeriod.durationInDays)

    return today <= limitDate
  })

  return Boolean(onGoingTrials.length)
}

export default checkUserHasOnGoingTestPeriod
